const breakpoints = {
  medium: 640,
  large: 1024,
  xlarge: 1200,
  xxlarge: 1440,
};

export default breakpoints;
